<template>
      <card>
        <list
          :columns="columns"
          :modalCreate="modalCreate"
          :removeLink="removeLink"
          :cardLink="cardLink"
          :isUpdate="true"
          :isAdd="true"
          :itemLink="itemLink"
          :setLink="setLink"
          :fields="fields"
          :searchDisable="true"
          @change="change"
          @changeFunction="changeFunction"
          v-model="val"
        />
      </card>
</template>
<script>
export default {
  name: "products",
  methods: {
    changeFunction(val) {},
    change(val) {},
  },
  data() {
    return {
      val: [],
      modalCreate: "role",
      fields: [
             {
        col:' col-12 col-md-12',
        key: "title",
        label: "Наименование",
        type: "field",
        textType: "text",
        isMultiLang:true
      },
      {
        col:' col-12 col-md-12',
        key: "code",
        label: "Код",
        type: "field",
        textType: "text",
      },
      {
        col:' col-12 col-md-12',
        key: "navigations",
        label: "Экраны",
        type: "selects",
        modal: "navigation",
        selectKey: "title",
      },
      ],
      /** APIs */
      removeLink: "",
      cardLink: "item_role",
      itemLink: "roles",
      setLink: "roles",
      columns: [
        {
          key: "id",
          title: "ID",
          checkbox: false,
          control: false,
          align: "left",
          timer: false,
          detail: false,
        },
        {
          key: "title",
          title: "Название",
          checkbox: false,
          control: false,
          align: "left",
          timer: false,
          detail: false,
        },
        {
          key: "code",
          title: "Код",
          checkbox: false,
          control: false,
          align: "left",
          timer: false,
          detail: false,
        },
        {
          detail: true,
          // remove: true,
        },
      ],
    };
  },
};
</script>
<style>
</style>
